import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'pitch/:hash',
    loadChildren: () => import('./external-pitch/external-pitch.module').then(m => m.ExternalPitchModule)
  },
  {
    path: ':hash',
    loadChildren: () => import('./external-pitch/external-pitch.module').then(m => m.ExternalPitchModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
